import { useParams } from "react-router-dom";
import AuthorsByLetterPage from "./AuthorsByLetterPage";
import AuthorSongsPage from "./AuthorSongsPage";

export default function AuthorPageRouter() {
    const { segment } = useParams();
    if (/^[a-z]$/i.test(segment)) return <AuthorsByLetterPage />;
    return <AuthorSongsPage />;
}
